<template>
  <a-modal :title="modal.title" v-model="modal.visible" :width="700">
    <div>
      <a-form layout="inline" :form="modal.form" :colon="false">
        <a-form-item label="国家">
          <a-select
            class="form-control"
            v-decorator="[
              'countryId',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择',
                  },
                ],
              },
            ]"
            showSearch
            :filterOption="filterByPY$t"
            :options="countryList"
            placeholder="请选择"
          ></a-select>
        </a-form-item>
      </a-form>
    </div>
    <template slot="footer">
      <a-button @click="handleOk" type="primary">确认</a-button>
    </template>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
import { getCountryList } from '@/service/getData'
export default {
  mixins: [toolMixin],
  data() {
    return {
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '选择国家',
        data: {},
      },
      countryList: [],
    }
  },
  methods: {
    async start(row) {
      this.countryList = await getCountryList()
      this.resetModal$t()
      this.modal.visible = true
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          const country = this.countryList.find(item => item.value === params.countryId)
          this.$emit('end', 'ok', country)
        }
      })
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
  },
}
</script>

<style></style>
